module.exports = __webpack_public_path__ + "static/media/mai_logo.png";